import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { ArrowUp } from '@phosphor-icons/react';

const ScrollButton = styled.button`
  position: fixed;
  bottom: 100px;
  right: 30px;
  background: rgba(58, 184, 255, 0.9);
  color: white;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  backdrop-filter: blur(8px);
  z-index: 1000;
  opacity: 0;
  transform: translateY(100px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  &.visible {
    opacity: 1;
    transform: translateY(0);
  }

  &:hover {
    background: #3AB8FF;
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    bottom: 90px;
    right: 20px;
  }
`;

const GoToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <ScrollButton 
      className={isVisible ? 'visible' : ''} 
      onClick={scrollToTop}
      aria-label="Go to top"
    >
      <ArrowUp weight="bold" />
    </ScrollButton>
  );
};

export default GoToTop; 